import spanishLang from 'element-ui/lib/locale/lang/es'
const messages = {
  ...spanishLang,
  "banner1": "La marca Solplanet ha sido creada por AISWEI",
  "banner2": "que anteriormente era",
  "banner3": "una subsidiaria de SMA China",
  "english": "Inglés",
  "polish": "Polaco",
  "spanish": "Español",
  "turkish": "Turco",
  "germany": "Alemán",
  "french": "Francés",
  "italian": "Italiano",
  "systemData1": "sistema",
  "installationLocation1": "instalación",
  "customerData1": "klient",
  "claimData": "Reclamación",
  "shippingAddress1": "envío",
  "customerData": "Cliente / Datos del cliente",
  "customerType": "Persona que hace la consulta",
  "selectCustomer": "Seleccione quién hace la consulta",
  "--None--": "--No--",
  "Installer": "Instaladores",
  "End-customer": "Clientes finales",
  "Distributor": "Distribuidor",
  "EPC": "EPC",
  "Other": "Otros",
  "companyName": "Nombre de la empresa",
  "typeCompanyName": "Escriba el nombre de la empresa",
  "contacts": "Nombre de contacto",
  "typeContacts": "Escriba un nombre de contacto",
  "contactInformation": "Número de teléfono",
  "typeContactInformation": "Escriba el número de teléfono",
  "shippingAddress": "Dirección de envío (recuerde que esta dirección se utilizará como dirección de envío en caso de que se necesite una sustitución).",
  "country": "País/Región",
  "typeCountry": "Escriba el nombre del país/región",
  "province": "Estado o provincia",
  "typeProvince": "Escriba el nombre del estado o la provincia",
  "city": "Ciudad ",
  "typeCity": "Escriba el nombre de la ciudad",
  "area": "Calle",
  "typeArea": "Escriba el nombre de la calle",
  "contacts01": "Teléfono móvil",
  "typeContacts01": "Escriba el número de teléfono móvil",
  "postCode": "Código postal",
  "typePostCode": "Escriba el código postal",
  "email": "Correo electrónico",
  "typeEmail": "Escriba la dirección de correo electrónico",
  "errorEmail": "Por favor ingrese una dirección de correo electrónico válida.",
  "installationLocation": "Ubicación de la instalación (use la dirección de envío",
  "purchaseDate": "Fecha de compra",
  "typePurchaseDate": "Especifique esta información",
  "installDate": "Fecha de instalación",
  "typeInstallDate": "Especifique esta información",
  "faultyDeviceType": "Tipo de dispositivo averiado",
  "selectFaultyDeviceType": "Especifique esta información",
  "faultDate": "Fecha de la avería",
  "typeFaultDate": "Especifique esta información",
  "deviceSerialNumber": "Número de serie del dispositivo",
  "typeDeviceSerialNumber": "Especifique esta información",
  "faultySymptom": "Síntoma de la avería",
  "selectFaultySymptom": "Especifique esta información",
  "errorDescription": "Descripción detallada del error",
  "typeErrorDescription": "Especifique esta información",
  "purchaseFileId": "Justificante de compra (adjunto)",
  "purchaseDesc": "El justificante de compra debe incluir el nombre del cliente, la dirección de instalación, el modelo de inversor y el justificante de pago",
  "breakFileId": "Certificado de la avería (adjunto)",
  "breakDesc": "Le rogamos que envíe una foto del detalle de la avería, el mensaje de error y la etiqueta del número de serie del producto",
  "upload": "Cargar",
  "systemData": "Datos del sistema (opcional)",
  "systemData01": "¿Es esta la primera reclamación que realiza para este lugar de instalación?",
  "Yes": "Sí",
  "No": "No",
  "Unknown": "Se desconoce",
  "systemData02": "Estado operativo de otros inversores usados en el mismo lugar de instalación",
  "systemData03": "Motivo de la reclamación anterior",
  "enterSystemData03": "Especifique esta información",
  "systemData04": "Detalle de la avería de otros inversores instalados en el mismo lado",
  "enterSystemData04": "Especifique esta información",
  "systemData05": "Condiciones ambientales de la instalación del inversor",
  "systemData0501": "Interior",
  "systemData0502": "Exterior (debajo de la sombra que proyecta el edificio o montado sobre una marquesina)",
  "systemData0503": "Exterior (inversor expuesto a la luz solar directa)",
  "systemData0504": "Encima del agua",
  "systemData0505": "Otros",
  "systemData06": "Condiciones ambientales de la instalación de los paneles solares",
  "systemData0601": "Sobre suelo",
  "systemData0602": "Sobre tejado",
  "systemData0603": "Sobre superficie de agua",
  "systemData0604": "Otros ",
  "systemData07": "Marca y modelo de los paneles solares",
  "typeSystemData07": "Especifique esta información",
  "systemData08": "Modelo de instalación fotovoltaica",
  "systemData0801": "Independiente",
  "systemData0802": "En paralelo",
  "pleaseSelect": "Seleccione una opción",
  "add": "Añadir",
  "delete": "eliminar",
  "pv10": "string solar panel(pieces)",
  "pv101": "Panel solar de cadena de PV1 (unidades)",
  "pv102": "Panel solar de cadena de PV2 (unidades)",
  "pv103": "Panel solar de cadena de PV3 (unidades)",
  "pv104": "Panel solar de cadena de PV4 (unidades)",
  "circuit01": "Tensión de circuito abierto (V)",
  "alternatingVoltage": "Tensión alterna",
  "l1l2": "Tensión de CA L1 - L2 (V)",
  "l1n": "Tensión de CA L1 - N (V)",
  "l2l3": "Tensión de CA L2 - L3 (V)",
  "l2n": "Tensión de CA L2 - N (V)",
  "l1l3": "Tensión de CA L1 - L3 (V)",
  "l3n": "Tensión de CA L3 - N (V)",
  "l1pe": "Tensión de CA L1 - PE (V)",
  "l3pe": "Tensión de CA L3 - PE (V)",
  "l2pe": "Tensión de CA L2 - PE (V)",
  "npe": "Tensión de CA N - PE (V)",
  "complaintFileId": "Cargar",
  "activeTip": "Aviso: Cuanto más detallada sea la información que nos facilite, más rápido podremos identificar el problema.",
  "submitBtn": "Enviar",
  "pleaseType": "Especifique esta información",
  "submitSuccess": "Presentar el éxito",
  "submitDesc": "Algunos campos obligatorios no están completados, por favor vuelva a enviar después de la confirmación.¡Gracias!",
  "typeUpload": "Por favor cargar",
  "resetUpload": "Volver a cargar",
  "selectErrorMessage": "Seleccione una opción",
  "errorMessage": "Otros",
  "MPPT": "MPPT",
  "chinese": "Chinese",
  "dutch": "Dutch",
  "hungary": "Hungary",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "Acepto los términos y condiciones de Solplanet",
  "iagree": "Acepto los términos y condiciones de Solplanet",
  "language": "Idioma",
  "ptbr": "Portugués (Brasil)",
  "zhtw": "Chino tradicional",
  "documentTitle": "Garantía │Solplanet",
  "validateNumber": "Introduzca un número entero"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/spanish.js